import { render, staticRenderFns } from "./StockInventoryTools.vue?vue&type=template&id=0fba5986&scoped=true&"
import script from "./StockInventoryTools.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTools.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryTools.vue?vue&type=style&index=0&id=0fba5986&scoped=true&lang=css&"
import style1 from "./StockInventoryTools.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba5986",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QTh,QTr,QTd,QSelect,QItem,QItemSection,QList,QItemLabel,QCheckbox,QInput,QBadge,QCardSection,QField} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QTh,QTr,QTd,QSelect,QItem,QItemSection,QList,QItemLabel,QCheckbox,QInput,QBadge,QCardSection,QField}, component.options.components || {})
